import {
  feetCubedNew,
  feetSquaredNew,
  inchesCubedNew,
  inchesSquaredNew,
  levelInchesNew,
  worldFeetNew,
  worldInchesNew,
} from "common/utils/nominalNumbers";

export const WORLD_ZERO_INCHES = worldInchesNew(0);
export const WORLD_ONE_INCH = worldInchesNew(1);

export const WORLD_ZERO_FOOT = worldFeetNew(0);
export const WORLD_ONE_FOOT = worldFeetNew(1);

export const LEVEL_ZERO_INCHES = levelInchesNew(0);
export const LEVEL_ONE_INCH = levelInchesNew(1);

export const INCHES_SQUARED_ZERO = inchesSquaredNew(0);
export const INCHES_SQUARED_ONE = inchesSquaredNew(1);

export const INCHES_CUBED_ZERO = inchesCubedNew(0);
export const INCHES_CUBED_ONE = inchesCubedNew(1);

export const FEET_SQUARED_ZERO = feetSquaredNew(0);
export const FEET_SQUARED_ONE = feetSquaredNew(1);

export const FEET_CUBED_ZERO = feetCubedNew(0);
export const FEET_CUBED_ONE = feetCubedNew(1);
